import { render, staticRenderFns } from "./VideosGlobalSettings.vue?vue&type=template&id=8715a648&scoped=true"
import script from "./VideosGlobalSettings.vue?vue&type=script&lang=js"
export * from "./VideosGlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./VideosGlobalSettings.vue?vue&type=style&index=0&id=8715a648&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8715a648",
  null
  
)

export default component.exports